<template>
    <div>
        <page-navigate></page-navigate>
        <div class="DiNapoli-crumbs pc">
            <div class="contentBox flex items-center">
                <span class="body-14_regular cursor-pointer">影响力联盟</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                    <path d="M0.5 0.5L5.5 5.5L0.5 10.5" stroke="black" stroke-opacity="0.48" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                <span class="body-14_medium">乔尔.帝纳波利</span>
            </div>
        </div>
        <div class="DiNapoli-section1">
            <div class="contentBox">
                <div class="left">
                    <h1 class="super_large-80_bold md-title-32_bold">乔尔.帝纳波利</h1>

                    <p class="p2 controlTitle content-14_regular md-body-14_regular">
                        帝纳波利是一位资深交易员，拥有超过55年的实战交易经验，至今仍每日交易。他的交易生涯成就斐然，包括60年代在纽交所交易Nifty
                        50指数，成功预测1987年的市场崩盘，以及在9/11事件后立即投身期货交易。自1982年合约开盘以来，他一直专注于标普指数期货的交易。帝纳波利在置换移动平均线、高级斐波那契技术、摆荡指标预测器和MACD预测器方面的研究享有盛誉。他创造的领先指标，使他成为备受追捧的专家。作为一名拥有超过25年经验的注册交易顾问（CTA），他曾在全球范围内举办讲座，并撰写了广受好评的著作《帝纳波利点位交易法》。该书在全球发行，已被翻译成13种语言，还将有更多版本面世。
                    </p>
                    <div class="showMore mobile md-body-14_regular">
                        <span class="show">点击展开</span>
                        <span class="hide">点击收起</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path
                                d="M10.6067 3.28241C10.8248 3.04745 11.1923 3.03369 11.4273 3.25179C11.6623 3.46996 11.6761 3.83748 11.458 4.07248L6.4257 9.49183C6.31584 9.61015 6.16151 9.67744 6.00005 9.67744C5.83859 9.67744 5.68426 9.61015 5.57439 9.49183L0.542136 4.07248L0.503956 4.02711C0.326509 3.79232 0.352448 3.45636 0.572756 3.25179C0.793063 3.04732 1.12975 3.04654 1.35073 3.24082L1.39345 3.28241L6.00005 8.24322L10.6067 3.28241Z"
                                fill="black" fill-opacity="0.48" />
                        </svg>
                    </div>
                    <ul class="leftBottom body-14_medium ">
                        <li>
                            <img src="@/assets/image/DiNapoli/headerLogo1.svg" alt="">
                            <div>斐波那契<br>技术传奇教父</div>
                        </li>
                        <li>
                            <img src="@/assets/image/DiNapoli/headerLogo2.svg" alt="">
                            <div>帝纳波利<br>点位法创始人</div>
                        </li>
                        <li>
                            <img src="@/assets/image/DiNapoli/headerLogo3.svg" alt="">
                            <div>黄金比率<br>应用头号权威</div>
                        </li>
                    </ul>
                </div>
                <div class="right">
                    <img class="pc" src="@/assets/image/DiNapoli/dinapoliHeader.png" alt="">
                    <img class="mobile" src="@/assets/image/DiNapoli/dinapoliHeaderM.png" alt="">

                </div>

            </div>
        </div>

        <div class="DiNapoli-section22" style="display: none;">
            <div class="contentBox">
                <div class="22-title">EBC DOP入门课程</div>
                <div class="22-describe">专为初学者设计，带您快速掌握帝纳波利交易技术。从市场基础到精准实操，助您自信开启交易之旅！</div>
                <div class="22-btn">免费领取</div>
            </div>
        </div>
        <div class="DiNapoli-section2">
            <div class="contentBox">
                <h2 class="title-48_bold md-title-24_bold scroll-fade-up">帝纳波利点位交易法</h2>
                <h3 class="subtitle-18_regular md-footnote-regular_12 scroll-fade-up">
                    《帝纳波利点位交易法》是迄今为止，关于斐波那契分析在价格枢轴应用上最全面的书籍。这本权威性的指南为交易者提供了宝贵的见解和技巧，使他们能够以更高的精准度和信心优化交易策略。</h3>
                <div class="section2-Container flex items-center justify-start scroll-fade-up">
                    <div class="info">
                        <ul class="body-14_regular">
                            <li>
                                <img src="@/assets/image/DiNapoli/section2Logo1.svg" alt="">
                                <span>
                                    全球黄金率投资交易最权威的著作
                                </span>
                            </li>
                            <li>
                                <img src="@/assets/image/DiNapoli/section2Logo2.svg" alt="">
                                <span>
                                    《帝纳波利点位交易法》因在实际交易中的卓越表现，被视为有史以来最伟大的交易书籍之一
                                </span>
                            </li>
                            <li>
                                <img src="@/assets/image/DiNapoli/section2Logo3.svg" alt="">
                                <span>
                                    在全球被翻译成超过13种语言
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="infoR">
                        <img src="@/assets/image/DiNapoli/DiNapoli-1N.png" alt="" />
                    </div>
                </div>

            </div>
        </div>

        <div class="DiNapoli-section3">
            <div class="contentBox">
                <h2 class="title-48_bold md-title-24_bold scroll-fade-up">帝纳波利MT4/MT5指标</h2>
                <h3 class="subtitle-18_regular md-footnote-regular_12 scroll-fade-up">
                    帝纳波利的领先指标，以其高效的趋势识别和支撑阻力价位的精准度量，受到全球交易者的青睐。通过融合多种技术分析方法，这些指标为交易者提供强大的决策支持，并显著提高交易成功率。
                </h3>
                <div class="section3-container flex items-center justify-between scroll-fade-up">
                    <div class="info">
                        <ul>
                            <li class="flex items-center">
                                <img src="@/assets/image/DiNapoli/section3Logo1.svg" alt="">
                                <div>
                                    <div class="body-14_medium">精准趋势捕捉</div>
                                    <div class="body-14_regular description">置换移动均线（DMA）系统能够快速识别市场趋势，及时抓住机遇</div>
                                </div>
                            </li>
                            <li class="flex items-center">
                                <img src="@/assets/image/DiNapoli/section3Logo2.svg" alt="">
                                <div>
                                    <div class="body-14_medium">有效的超买/超卖信号</div>
                                    <div class="body-14_regular description">摆动指标能够发出市场转折的可靠信号</div>
                                </div>
                            </li>
                            <li class="flex items-center">
                                <img src="@/assets/image/DiNapoli/section3Logo3.svg" alt="">
                                <div>
                                    <div class="body-14_medium">精准的支撑位和阻力位</div>
                                    <div class="body-14_regular description">基于斐波那契分位水平优化交易策略</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="infoR">
                        <img src="@/assets/image/DiNapoli/section3-pg.png" alt="">
                        <div class="infoRTxt flex justify-between items-center">
                            <img src="@/assets/image/DiNapoli/section3-star.svg" alt="">
                            <span>3 bottoms</span>
                            <img src="@/assets/image/DiNapoli/section3-star.svg" alt="">
                            <span>6 fibnodes</span>
                            <img src="@/assets/image/DiNapoli/section3-star.svg" alt="">
                            <span>2 DiNapoli confluence</span>
                        </div>
                    </div>
                </div>
                <a rel="nofollow" :href="signupUrl" target="_blank" class="primary-default_large sectionBtn scroll-fade-up">免费领取</a>
            </div>
        </div>

        <div class="DiNapoli-section4">
            <div class="contentBox">
                <h2 class="title-48_bold md-title-24_bold scroll-fade-up">深受专业投资者好评</h2>
                <div class="swiper section4-slide scroll-fade-up">
                    <div class="swiper-wrapper section4CardList flex items-stretch">
                        <div class="swiper-slide section4Card">
                            <img src="@/assets/image/DiNapoli/stars.png" alt="">
                            <div class="content-16_regular evaluate">这么多年来，我所认识的所有真正赚了大钱的优秀交易员，都上过你的课</div>
                            <div class="writerPart">
                                <div class="header">G</div>
                                <div>
                                    <div class="writerName subtitle-20_bold">George Lane</div>
                                    <div class="writerWork footnote-regular_12">伊利诺伊州Watseka总裁，随机指标（RSI）发明人</div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide section4Card">
                            <img src="@/assets/image/DiNapoli/stars.png" alt="">
                            <div class="content-16_regular evaluate">您无法买到经验，但帝纳波利的书能让您避免昂贵的教训。</div>
                            <div class="writerPart">
                                <div class="header">W</div>
                                <div>
                                    <div class="writerName subtitle-20_bold">Walter Bressert</div>
                                    <div class="writerWork footnote-regular_12">一位拥有超过30年行业经验的市场专家和交易专家，创立了Bressert
                                        Trading Group，致力于提供专业的交易策略和服务。</div>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide section4Card">
                            <img src="@/assets/image/DiNapoli/stars.png" alt="">
                            <div class="content-16_regular evaluate">
                                他在《帝纳波利点位交易法》中介绍的方法非常实用，在牛熊市以及股票和期货交易中都能同样有效地发挥作用。新手交易员可以缩短几年的学习曲线，而经验丰富的交易员也能学会新的技巧。
                            </div>
                            <div class="writerPart">
                                <div class="header">L</div>
                                <div>
                                    <div class="writerName subtitle-20_bold">Linda Raschke</div>
                                    <div class="writerWork footnote-regular_12">LBR Group的杰出交易者、作家、教育家</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="DiNapoli-section5">
            <div class="contentBox">
                <h2 class="title-48_bold md-title-24_bold scroll-fade-up">了解更多关于帝纳波利点位法</h2>
                <h3 class="subtitle-18_regular md-footnote-regular_12 scroll-fade-up">了解更多关于帝纳波利点位法和帝纳波利指标专家</h3>
                <a class="primary-default_large sectionBtn scroll-fade-up" href="https://www.fibnodes.com/index.asp" rel="nofollow"
                    target="_blank">了解更多</a>
                <div class="dinapoli-shell scroll-fade-up">
                   
                    <div class="swiper DiNapoli-slide" id="DiNapoliSlide">
                        <div class="swiper-wrapper">
                           
                            <div class="swiper-slide">
                                <img src="@/assets/image/DiNapoli/DiNapoli-4.jpg" alt="" />
                            </div>
                           
                        </div>
                    </div>
                   
                    <!-- <div class="swiper-pagination"></div> -->

                </div>
            </div>

        </div>
        <page-footer></page-footer>
    </div>
</template>

<script>
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
import fadeAnimate from "../mixins/fadeAnimate.js";
import { mapGetters } from 'vuex';

export default {
    mixins: [fadeAnimate],

    data() {
        return {
        }
    },
    computed: {
...mapGetters([
            'signupUrl',
        ])
    },
    destroyed() {
    },
    created() {
    },
    mounted() {
        this.initPage()

    },
    methods: {
        initPage() {
            window.matchMedia('(max-width:996px)').matches && new Swiper('.section4-slide', {
                loop: true,          // 循环
                speed: 6000,         // 单次动画时长 3s
                autoplay: {
                    delay: 0,          // 0 延时，动画结束立即下一帧
                    disableOnInteraction: false,
                    stopOnLastSlide: false,
                },
            });


            function createPcCarousel({ root, viewport, pagination, prevBtn, nextBtn }) {
                const slides = viewport ? Array.from(viewport.children) : [];
                let index = 0;
                let isAnimating = false;
                let timer = null;

                function mod(n, m) { return ((n % m) + m) % m; }

                function applyState() {
                    if (!slides.length) return;
                    const prev = mod(index - 1, slides.length);
                    const next = mod(index + 1, slides.length);

                    slides.forEach((el, i) => {
                        el.classList.remove('is-active', 'is-prev', 'is-next', 'is-hidden');
                        if (i === index) el.classList.add('is-active');
                        else if (i === prev) el.classList.add('is-prev');
                        else if (i === next) el.classList.add('is-next');
                        else el.classList.add('is-hidden');
                    });

                    if (pagination) {
                        Array.from(pagination.querySelectorAll('button')).forEach((d, i) => {
                            d.setAttribute('aria-current', i === index ? 'true' : 'false');
                        });
                    }
                }

                function goTo(i) {
                    if (isAnimating || slides.length <= 1) return;
                    isAnimating = true;
                    index = mod(i, slides.length);
                    applyState();
                    timer = window.setTimeout(() => { isAnimating = false; }, 560);
                }
                function prev() { goTo(index - 1); }
                function next() { goTo(index + 1); }

                function onPrev() { prev(); }
                function onNext() { next(); }
                function onViewportClick(e) {
                    const target = e.target?.closest?.('.swiper-slide');
                    if (!target) return;
                    if (target.classList.contains('is-prev')) prev();
                    if (target.classList.contains('is-next')) next();
                }

                prevBtn?.addEventListener('click', onPrev);
                nextBtn?.addEventListener('click', onNext);
                viewport?.addEventListener('click', onViewportClick);

                // 初始化分页点（PC）
                if (pagination) {
                    pagination.innerHTML = '';
                    slides.forEach((_, i) => {
                        const dot = document.createElement('button');
                        dot.type = 'button';
                        dot.className = 'swiper-pagination-bullet';
                        dot.setAttribute('aria-label', `切换到第 ${i + 1} 张`);
                        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
                        dot.addEventListener('click', () => goTo(i));
                        pagination.appendChild(dot);
                    });
                }

                applyState();

                return {
                    destroy() {
                        prevBtn?.removeEventListener('click', onPrev);
                        nextBtn?.removeEventListener('click', onNext);
                        viewport?.removeEventListener('click', onViewportClick);
                        if (timer) window.clearTimeout(timer);
                        slides.forEach((el) => el.classList.remove('is-active', 'is-prev', 'is-next', 'is-hidden'));
                    }
                };
            }

            function createMobileSwiper({ root, container, paginationEl }) {
                root.classList.add('is-mobile');
                return new Swiper(container, {
                    loop: true,
                    speed: 420,
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: false,
                    },
                    slidesPerView: 1,
                    spaceBetween: 20,
                    pagination: {
                        el: paginationEl,
                        clickable: true,
                    },
                });
            }

            const root = document.querySelector('.DiNapoli-section5');
            const viewport = root?.querySelector('#DiNapoliSlide .swiper-wrapper');
            const pagination = root?.querySelector('.swiper-pagination');
            const prevBtn = root?.querySelector('.dinapoli-prev');
            const nextBtn = root?.querySelector('.dinapoli-next');

            const mq = window.matchMedia('(max-width: 996px)');
            let pcController = null;
            let mobileSwiper = null;

            function enablePc() {
                root?.classList.remove('is-mobile');
                if (mobileSwiper) {
                    mobileSwiper.destroy(true, true);
                    mobileSwiper = null;
                    viewport?.removeAttribute('style');
                    Array.from(viewport?.children || []).forEach((el) => el.removeAttribute('style'));
                }
                if (!pcController) {
                    pcController = createPcCarousel({ root, viewport, pagination, prevBtn, nextBtn });
                }
            }

            function enableMobile() {
                if (pcController) {
                    pcController.destroy();
                    pcController = null;
                }
                if (!mobileSwiper) {
                    //mobileSwiper = createMobileSwiper({ root, container: '#DiNapoliSlide', paginationEl: pagination });
                }
            }

            function syncMode() {
                if (!root || !viewport) return;
                if (mq.matches) enableMobile();
                else enablePc();
            }

            syncMode();
            mq.addEventListener?.('change', syncMode);
            mq.addListener?.(syncMode);

            document.querySelector('.DiNapoli-crumbs span:nth-child(1)').addEventListener('click', () => {
                const currentUrl = window.location.href;
                const newUrl = currentUrl.replace(/\/[^\/]*$/, '/affiliate-programmes');
                window.location.href = newUrl;
            })
            let controlTitle = document.querySelector('.controlTitle')
            document.querySelector('.DiNapoli-section1 .showMore').addEventListener('click', () => {
                controlTitle.classList.toggle('showAll')
                document.querySelector('.DiNapoli-section1 .showMore').classList.toggle('showAll')
            })

         
        }
    }
}

</script>
<style>
      :root {
        --active-w: 690px;
        --active-h: 390px;
        --side-w: 491px;
        --side-h: 276px;
        --mid-w: 960px;
        /* 中间轮播图区域宽度 */
        --shell-w: 1200px;
        /* 整体宽度 */
        --overlap: 356px;
        /* 背面图嵌入 active 的宽度（491-135=356，对应每侧露出 135） */
        --btn-size: 64px;
        --btn-hover: #a52933;
        --radius: 20px;
        --ease: cubic-bezier(0.2, 0.8, 0.2, 1);
        --shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
        --shadow-soft: 0 18px 40px rgba(0, 0, 0, 0.12);
    }
    .DiNapoli-section5 .swiper-pagination {
    bottom: -40px;
    left: 50%;
    transform: translateX(-50%);
}

.DiNapoli-section5 .swiper-pagination-bullet {
    width: 12px;
    height: 2px;
    border: 0;
    padding: 0;
    border-radius: var(--ebc-corner-radius-full);
    background: rgba(0, 0, 0, 0.12);
    opacity: 1;
    margin: 0 6px !important;
}

.DiNapoli-section5 .swiper-pagination-bullet[aria-current="true"],
.DiNapoli-section5 .swiper-pagination-bullet-active {
    background: var(--ebc-brand-secondary-red);
    width: 32px;
}
</style>
<style scoped>
.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
}

.DiNapoli-section2 {
    padding: 120rem 0;
    background-color: #fafafa;
}

h2,
h3 {
    text-align: center;
}

.sectionBtn {
    width: fit-content;
    min-width: 160rem;
    margin-inline: auto;
}

.sectionBtn:hover {
    color: #fff;
}

.DiNapoli-section2 h3 {
    margin: 24rem 0 64rem;
    color: var(--ebc-text-secondary);
}

.section2-Container {
    border-radius: var(--ebc-corner-radius-rc24);
    background: var(--ebc-neutral-bg_a);
    margin-top: 64rem;
    gap: 102rem;
    overflow: hidden;
    position: relative;
    height: 430rem;
    padding-left: 100rem;
}

.section2-Container .info img {
    width: 32rem;
    height: 32rem;
    margin-right: 20rem;
}

.ar .section2-Container {
    padding-left: 0;
    padding-right: 50rem;
}

.ar .section2-Container .info img {
    margin-left: 20rem;
}

.section2-Container .info ul {
    max-width: 350rem;
}

.section2-Container .info ul li {
    display: flex;
    align-items: center;
}

.section2-Container .info ul li {
    margin-bottom: 40rem;
    color: var(--ebc-text-secondary);
}

.section2-Container .info ul li:last-child {
    margin-bottom: 0;
}

.DiNapoli-section2 .infoR {
    position: absolute;
    left: 386rem;
    top: 61rem;
}

.ar .DiNapoli-section2 .infoR {
    left: unset;
    right: 386rem;
}

.DiNapoli-section2 .infoR img {
    height: 308rem;
    width: auto;
}

@media (max-width: 996px) {
    .contentBox {
        margin-inline: 32rem;
    }

    .DiNapoli-section2 h3 {
        margin: 16rem 0 80rem;
    }

    .DiNapoli-section2 {
        padding: 160rem 0;
    }

    .section2-Container {
        border-radius: 16px;
        padding: 460rem 32rem 80rem;
        height: auto;
    }

    .DiNapoli-section2 .infoR {
        left: -96rem;
        top: 80rem;
        margin-bottom: 80rem;
    }

    .ar .DiNapoli-section2 .infoR {
        left: -96rem;
        right: unset;
    }

    .DiNapoli-section2 .infoR img {
        width: 900rem;
    }

    .section2-Container .info ul {
        max-width: unset;
    }

    .section2-Container .info ul li {
        flex-direction: column;
        text-align: center;
    }

    .section2-Container .info ul li img {
        width: 64rem;
        height: 64rem;
        margin-bottom: 24rem;
    }

    .section2-Container .info ul li:nth-child(-n + 2) {
        margin-bottom: 48rem;
    }
}

.DiNapoli-section3 {
    padding-bottom: 120rem;
    background-color: #fafafa;
}

.DiNapoli-section3 h3 {
    color: var(--ebc-text-secondary);
    margin: 24rem 0 64rem;
}

.section3-container {
    border-radius: var(--ebc-corner-radius-rc24);
    background: var(--ebc-neutral-bg_a);
    padding: 85rem 140rem 85rem 100rem;
    margin: 64rem 0;
    gap: 102rem;
}

.section3-container .info img {
    width: 32rem;
    height: 32rem;
    margin-right: 20rem;
}

.ar .section3-container .info img {
    margin-right: 0;
    margin-left: 20rem;
}

.section3-container .info ul {
    max-width: 465rem;
}

.section3-container .info ul .description {
    color: var(--ebc-text-secondary);
    margin-top: 5rem;
}

.section3-container .info ul li:nth-child(-n + 2) {
    margin-bottom: 40rem;
}

.section3-container .infoR img {
    margin-bottom: 40rem;
    margin-left: 22rem;
    height: 210rem;
    width: auto;
}

.section3-container .infoR .infoRTxt img {
    width: 10rem;
    height: auto;
    margin: 0;
}

.section3-container .infoR span {
    color: #9f734c;
    font-size: 14rem;
    font-weight: 700;
}

@media (max-width: 996px) {
    .DiNapoli-section3 h3 {
        margin: 16rem 0 80rem;
    }

    .section3-container {
        border-radius: 16px;
        padding: 80rem 32rem;
        flex-direction: column;
        margin: 80rem 0;
    }

    .section3-container .info {
        order: 2;
    }

    .section3-container .info ul {
        max-width: unset;
    }

    .section3-container .infoR img {
        height: 334rem;
        margin-bottom: 60rem;
        margin-left: 34rem;
    }

    .section3-container .infoR span {
        font-size: 22rem;
    }

    .section3-container .infoR .infoRTxt img {
        width: 15rem;
    }

    .section3-container .info ul li {
        flex-direction: column;
        gap: 24rem;
        text-align: center;
    }

    .section3-container .info ul li img {
        width: 64rem;
        height: 64rem;
    }

    .section3-container .info ul li:nth-child(-n + 2) {
        margin-bottom: 48rem;
    }

    .section3-container .info ul .description {
        margin-top: 12rem;
    }

    .sectionBtn {
        height: 80rem !important;
        font-size: 28rem !important;
    }
}

.DiNapoli-section4 {
    background: #fff;
    padding: 120rem 0;
}

.DiNapoli-section4 h2 {
    margin-bottom: 64rem;
}

.section4CardList {
    gap: 24rem;
}

@media (min-width: 996px) {

    .section4-slide,
    .section4CardList {
        overflow: visible !important;
    }

}

.section4CardList .swiper-slide {
    height: auto !important;
}

.section4Card {
    flex: 0 0 384rem;
    border-radius: 16px;
    background: var(--ebc-neutral-bg_b, #f7f7f7);
    display: flex;
    flex-direction: column;
    padding: 32rem 22rem;
    min-height: 356px;
    transition: all 0.5s ease-in-out;
    border: 1px solid transparent;
}

.section4Card:hover {
    transform: translateY(-16rem);
    border: 1px solid var(--ebc-brand-secondary-gold);
    background: var(--ebc-neutral-beige, #f9f6f2);
}

.section4Card img {
    height: 24rem;
    width: 120rem;
}

.section4Card .evaluate {
    margin: 24rem 0 auto;
}

.section4Card .writerPart {
    display: flex;
    gap: 16rem;
    margin-top: 15rem;
}

.section4Card .writerPart .writerWork {
    color: var(--ebc-text-secondary);
    margin-top: 2rem;
    text-overflow: ellipsis;
    display: -webkit-box;
    /* 必须 */
    -webkit-box-orient: vertical;
    /* 必须 */
    -webkit-line-clamp: 1;
    /* 行数，想省略几行就写几 */
    overflow: hidden;
}

.section4Card .writerPart .header {
    flex: 0 0 48rem;
    width: 48rem;
    height: 48rem;
    border-radius: 50%;
    background: var(--ebc-brand-primary-burgundy);
    font-size: 28rem;
    font-weight: 500;
    text-align: center;
    line-height: 48rem;
    color: #e6ddcf;
}

@media (max-width: 996px) {
    .DiNapoli-section4 {
        padding: 160rem 0;
        overflow: hidden;
    }

    .DiNapoli-section4 h2 {
        margin-bottom: 80rem;
    }

    .section4CardList {
        gap: 48rem;
        transition-timing-function: linear !important;
    }

    .section4Card {
        flex: 0 0 768rem;
        padding: 64rem 48rem;
    }

    .section4Card:hover {
        transform: translateY(0rem);
        background: var(--ebc-neutral-bg_b, #f7f7f7);
        border: 1px solid transparent;
    }

    .section4Card img {
        height: 48rem;
        width: 240rem;
    }

    .section4Card .evaluate {
        margin: 48rem 0 auto;
    }

    .section4Card .writerPart {
        gap: 32rem;
    }

    .section4Card .writerPart .writerWork {
        margin-top: 4rem;
    }

    .section4Card .writerPart .header {
        flex: 0 0 96rem;
        width: 96rem;
        height: 96rem;
        font-size: 48rem;
        line-height: 96rem;
    }
}

.DiNapoli-section5 {
    padding: 120rem 0 170rem;
    background: #fafafa;
}

.DiNapoli-section5 h3 {
    color: var(--ebc-text-secondary);
    margin: 24rem 0 40rem;
}

@media (min-width: 996px) {
    .dinapoli-shell {
        margin-top: 64rem;
    }

  

    /* =========================
         轮播布局（只作用于该模块）
         ========================= */

    /* 1200 外框：左右按钮 + 中间 960 轮播区域 */
    .DiNapoli-section5 .dinapoli-shell {
        width: var(--shell-w);
        max-width: 100%;
        display: grid;
        grid-template-columns: 120px var(--mid-w) 120px;
        grid-template-rows: auto auto;
        column-gap: 0;
        row-gap: 18px;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .DiNapoli-slide {
        width: var(--mid-w);
        height: var(--active-h);
        position: relative;
        overflow: hidden;
        /* 严格裁切中间 960px 区域 */
        grid-column: 2;
        grid-row: 1;
    }

    .DiNapoli-slide .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
    }

    /* 每个 slide：绝对定位（参考 carousel_center_overlap） */
    .DiNapoli-slide .swiper-slide {
        position: absolute;
        top: 50%;
        left: 50%;
        width: var(--side-w);
        height: var(--side-h);
        border-radius: var(--radius);
        overflow: hidden;
        background: #eee;
        will-change: transform, opacity, filter;
        transition: transform 520ms var(--ease), opacity 520ms var(--ease),
            filter 520ms var(--ease), box-shadow 520ms var(--ease);
        z-index: 0;
        opacity: 0;
        pointer-events: none;
        transform: translate(-50%, -50%) scale(0.98);
    }

    .DiNapoli-slide .swiper-slide img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    /* 左右背面偏移：嵌入 overlap（每侧露出=side-overlap=135） */
    .DiNapoli-slide {
        --side-offset: calc((var(--active-w) / 2) - var(--overlap) + (var(--side-w) / 2));
    }

    .DiNapoli-slide .swiper-slide.is-active {
        width: var(--active-w);
        height: var(--active-h);
        z-index: 3;
        opacity: 1;
        filter: none;
        pointer-events: auto;
        transform: translate(-50%, -50%) translateZ(0);
    }

    .DiNapoli-slide .swiper-slide.is-prev,
    .DiNapoli-slide .swiper-slide.is-next {
        z-index: 1;
        opacity: 0.36;
        filter: saturate(0.85) brightness(1.04);
        pointer-events: auto;
    }

    .DiNapoli-slide .swiper-slide.is-prev {
        transform: translate(-50%, -50%) translateX(calc(-1 * var(--side-offset))) translateZ(-10px);
    }

    .DiNapoli-slide .swiper-slide.is-next {
        transform: translate(-50%, -50%) translateX(var(--side-offset)) translateZ(-10px);
    }

    .DiNapoli-slide .swiper-slide.is-hidden {
        opacity: 0;
        filter: blur(2px);
        transform: translate(-50%, -50%) scale(0.98);
        pointer-events: none;
    }

    .DiNapoli-section5 .dinapoli-nav {
        position: relative;
        width: var(--btn-size);
        height: var(--btn-size);
        border-radius: 999px;
        border: 0;
        padding: 0;
        background: transparent;
        color: #000;
        /* SVG stroke: currentColor */
        display: grid;
        place-items: center;
        cursor: pointer;
        transition: background-color 200ms cubic-bezier(0.2, 0.8, 0.2, 1),
            color 200ms cubic-bezier(0.2, 0.8, 0.2, 1);
        z-index: 5;
        justify-self: center;
    }
.DiNapoli-section5 .dinapoli-nav:hover svg{
    fill: #a53933;
}
    .DiNapoli-section5 .dinapoli-nav:hover svg path {
        stroke: var(--ebc-text-primary_white);
    }

    .DiNapoli-section5 .dinapoli-nav:focus-visible {
        outline: 3px solid rgba(165, 41, 51, 0.35);
        outline-offset: 4px;
    }

    .DiNapoli-section5 .dinapoli-prev {
        grid-column: 1;
        grid-row: 1;
    }

    .DiNapoli-section5 .dinapoli-next {
        grid-column: 3;
        grid-row: 1;
    }

    .DiNapoli-section5 .dinapoli-next svg {
        transform: rotate(180deg);
    }
}



@media (max-width: 996px) {
    .DiNapoli-section5 {
        padding: 160rem 0 225rem;
    }

    .DiNapoli-section5 h3 {
        margin: 16rem 0 80rem;
    }

    .dinapoli-shell {
        margin-top: 80rem;
        position: relative;
    }

    .dinapoli-shell img {
        border-radius: 8px;
    }

    .dinapoli-shell button {
        display: none;
    }
}

.DiNapoli-crumbs {
    background-color: #fff;
    padding: calc(80px + 16rem) 0 16rem;
}

.DiNapoli-crumbs span:nth-child(1) {
    color: var(--ebc-text-secondary);
}

.DiNapoli-crumbs svg {
    margin-inline: 16rem;
    width: 5px;
    height: 10px;
}

.DiNapoli-section1 {
    padding-bottom: 17rem;
    background: linear-gradient(180deg, #fafafa 0%, #fff 100%);
}

.DiNapoli-section1 .contentBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 80rem;
}

.DiNapoli-section1 .contentBox .right {
    flex: 0 0 474rem;
}

.DiNapoli-section1 .contentBox .right img {
    width: 474rem;
    height: auto;
}

.DiNapoli-section1 .controlTitle {
    color: var(--ebc-text-secondary);
    margin: 48rem 0 64rem;
}

.DiNapoli-section1 .leftBottom {
    display: flex;
    gap: 56rem;
    color: var(--ebc-brand-secondary-gold);
}

.DiNapoli-section1 .leftBottom.enType {
    flex-direction: column;
    gap: 16rem;
}

.DiNapoli-section1 .leftBottom li {
    display: flex;
    gap: 12rem;
    align-items: center;
}

.DiNapoli-section1 .leftBottom li img {
    width: 48rem;
    height: 48rem;
}

.DiNapoli-section1 .leftBottom.enType li img {
    width: 28rem;
    height: 28rem;
}

@media (max-width: 996px) {
    .DiNapoli-section1 {
        background: #fff;
        padding: 60rem 0 160rem;
    }

    .DiNapoli-section1 .contentBox {
        flex-direction: column;
        gap: 32rem;
        text-align: center;
    }

    .DiNapoli-section1 .contentBox .left {
        order: 2;
    }

    .DiNapoli-section1 .contentBox .right {
        flex: 1;
    }

    .DiNapoli-section1 .contentBox .showMore {
        color: var(--ebc-brand-secondary-red);
        margin-bottom: 80rem;
    }

    .DiNapoli-section1 .contentBox .showMore svg {
        margin-left: 9rem;
        transform: translateY(-3rem);
    }

    .ar .DiNapoli-section1 .contentBox .showMore svg {
        margin-left: 0;
        margin-right: 9rem;
    }

    .DiNapoli-section1 .contentBox .showMore.showAll svg {
        transform: translateY(-3rem) rotate(180deg);
    }

    .DiNapoli-section1 .contentBox .showMore .show {
        display: inline-block;
    }

    .DiNapoli-section1 .contentBox .showMore .hide {
        display: none;
    }

    .DiNapoli-section1 .contentBox .showMore.showAll .show {
        display: none;
    }

    .DiNapoli-section1 .contentBox .showMore.showAll .hide {
        display: inline-block;
    }

    .DiNapoli-section1 .controlTitle {
        margin: 16rem 0 40rem;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* 必须 */
        -webkit-box-orient: vertical;
        /* 必须 */
        -webkit-line-clamp: 4;
        /* 行数，想省略几行就写几 */
        overflow: hidden;
    }

    .DiNapoli-section1 .controlTitle.showAll {
        -webkit-line-clamp: 100;
    }

    .DiNapoli-section1 .leftBottom {
        justify-content: center;
    }

    .DiNapoli-section1 .leftBottom.enType {
        justify-content: flex-start;
    }

    .DiNapoli-section1 .leftBottom li {
        flex-direction: column;
        gap: 16rem;
        justify-content: center;
        align-items: center;
    }

    .DiNapoli-section1 .leftBottom.enType li {
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        text-align: left;
    }

    .DiNapoli-section1 .leftBottom li img {
        width: 80rem;
        height: 80rem;
    }

    .DiNapoli-section1 .leftBottom.enType li img {
        width: 56rem;
        height: 56rem;
    }
}
</style>
